(function () {
  var storageKey = 'everlastRecentlyViewedProducts';
  var storageLimit = 8;
  var displayLimit = 4;

  function createElement(tagName, className, text) {
    var element = document.createElement(tagName);

    if (className) element.className = className;
    if (text) element.textContent = text;

    return element;
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function' && window.Shop && Shop.moneyFormat) {
      return Shopify.formatMoney(cents, Shop.moneyFormat);
    }

    return '$' + (cents / 100).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function getProductSalePrices(productData) {
    var price = productData.price || 0;
    var comparePrice = productData.compare_at_price || productData.compare_at_price_min || 0;

    if ((!comparePrice || comparePrice <= price) && Array.isArray(productData.variants)) {
      productData.variants.some(function (variant) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          price = variant.price;
          comparePrice = variant.compare_at_price;
          return true;
        }

        return false;
      });
    }

    if (!comparePrice || comparePrice <= price) return null;

    return {
      price: price,
      comparePrice: comparePrice,
      saleBadge: Math.round((comparePrice - price) * 100 / comparePrice) + '% off'
    };
  }

  function updateStoredProduct(updatedProduct) {
    try {
      var storedProducts = JSON.parse(window.localStorage.getItem(storageKey) || '[]');

      if (!Array.isArray(storedProducts)) return;

      storedProducts = storedProducts.map(function (product) {
        if (product && product.handle === updatedProduct.handle) return updatedProduct;
        return product;
      });

      window.localStorage.setItem(storageKey, JSON.stringify(storedProducts));
    } catch (error) {}
  }

  function renderSaleBadge(media, product) {
    if (!product.onSale || !product.saleBadge || media.querySelector('.recently-viewed-card-badge-sale')) return;

    media.appendChild(createElement('span', 'recently-viewed-card-badge recently-viewed-card-badge-sale', product.saleBadge));
  }

  function renderPrice(priceElement, product) {
    priceElement.textContent = '';
    priceElement.className = 'recently-viewed-card-price';

    if (product.onSale && product.comparePrice) {
      priceElement.className += ' recently-viewed-card-price--on-sale';
      priceElement.appendChild(createElement('span', 'recently-viewed-card-sale-badge', product.saleBadge || 'Sale'));

      var priceRow = createElement('span', 'recently-viewed-card-price-row');
      priceRow.appendChild(createElement('span', 'recently-viewed-card-price-current', product.price));
      priceRow.appendChild(createElement('span', 'recently-viewed-card-price-compare', product.comparePrice));
      priceElement.appendChild(priceRow);
    } else if (product.price) {
      priceElement.textContent = product.price;
    }
  }

  function refreshStoredSaleData(product, media, priceElement) {
    if (!product.url || product.comparePrice) return;

    fetch(product.url.replace(/\?.*$/, '').replace(/\/$/, '') + '.js')
      .then(function (response) {
        if (!response.ok) throw new Error('Product data unavailable');
        return response.json();
      })
      .then(function (productData) {
        var salePrices = getProductSalePrices(productData);

        if (!salePrices) return;

        product.price = formatMoney(salePrices.price);
        product.comparePrice = formatMoney(salePrices.comparePrice);
        product.onSale = true;
        product.saleBadge = salePrices.saleBadge;

        renderSaleBadge(media, product);
        renderPrice(priceElement, product);
        updateStoredProduct(product);
      })
      .catch(function () {});
  }

  function createProductCard(product, index) {
    var card = createElement('article', 'recently-viewed-card recently-viewed-card-accent-' + ((index % 4) + 1));
    var link = createElement('a', 'recently-viewed-card-link');
    var media = createElement('div', 'recently-viewed-card-media');
    var body = createElement('div', 'recently-viewed-card-body');
    var title = createElement('h3', 'recently-viewed-card-title', product.title);
    var footer = createElement('div', 'recently-viewed-card-footer');

    link.href = product.url;
    link.setAttribute('aria-label', 'View ' + product.title);
    title.title = product.title;

    if (product.image) {
      var image = createElement('img', 'recently-viewed-card-image');

      image.src = product.image;
      image.alt = product.imageAlt || product.title;
      image.loading = 'lazy';
      image.width = 600;
      image.height = 600;
      media.appendChild(image);
    } else {
      media.appendChild(createElement('div', 'recently-viewed-card-placeholder'));
    }

    renderSaleBadge(media, product);

    if (product.type) {
      body.appendChild(createElement('span', 'recently-viewed-card-type', product.type));
    }

    body.appendChild(title);

    if (product.price) {
      var priceElement = createElement('span', 'recently-viewed-card-price');
      renderPrice(priceElement, product);
      footer.appendChild(priceElement);
      refreshStoredSaleData(product, media, priceElement);
    }

    var action = createElement('span', 'recently-viewed-card-action', 'View product ');
    var arrow = createElement('span', '', '\u2192');
    arrow.setAttribute('aria-hidden', 'true');
    action.appendChild(arrow);
    footer.appendChild(action);
    body.appendChild(footer);
    link.appendChild(media);
    link.appendChild(body);
    card.appendChild(link);

    return card;
  }

  function initializeRecentlyViewedProducts() {
    var currentProductElement = document.querySelector('[data-recently-viewed-current-product]');
    var section = document.querySelector('[data-recently-viewed-section]');
    var grid = document.querySelector('[data-recently-viewed-grid]');

    if (!currentProductElement || !section || !grid) return;

    try {
      var currentProduct = JSON.parse(currentProductElement.textContent);
      var storedProducts = JSON.parse(window.localStorage.getItem(storageKey) || '[]');

      if (!Array.isArray(storedProducts)) storedProducts = [];

      var productsToDisplay = storedProducts
        .filter(function (product) {
          return product && product.handle && product.handle !== currentProduct.handle;
        })
        .slice(0, displayLimit);

      if (productsToDisplay.length) {
        var fragment = document.createDocumentFragment();

        productsToDisplay.forEach(function (product, index) {
          fragment.appendChild(createProductCard(product, index));
        });

        grid.appendChild(fragment);
        section.hidden = false;

        var productPage = section.closest('[data-section-type="page-product"]') ||
          document.querySelector('[data-section-type="page-product"]');
        if (productPage) productPage.classList.add('has-recently-viewed-products');
      }

      var updatedProducts = [currentProduct].concat(
        storedProducts.filter(function (product) {
          return product && product.handle !== currentProduct.handle;
        })
      ).slice(0, storageLimit);

      window.localStorage.setItem(storageKey, JSON.stringify(updatedProducts));
    } catch (error) {
      section.hidden = true;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeRecentlyViewedProducts);
  } else {
    initializeRecentlyViewedProducts();
  }
})();
